module.exports = __webpack_public_path__ + "img/1.4-人工智能.72bdfc26.svg";